/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const FETCH_STATEMENTS_DETAILS_GQL = gql`
  query GetTDStatements($statementsReq: StatementsReq!) {
  getTDStatements(statementsReq: $statementsReq) {
    documentIds {
      document {
        LoadDate
        StatementStartDate
        documentId
      }
    }
  }
}
`;

export const useFetchStatementsDetails = (req: any) => {
  const variables = {
    statementsReq: {
      maxResults: req.maxResults,
      fromYear: req.fromYear,
      toYear: req.toYear,
      userId: req.userId
    }
  };
  const { data, loading, error } = useQuery(FETCH_STATEMENTS_DETAILS_GQL, {
    variables,
    fetchPolicy: 'network-only'
  });

  return { data, loading, error };
};
